module.exports = __webpack_public_path__ + "img/couples-078.5651b66e.jpg";